export default __webpack_public_path__ + "assets/models/6ed8a0bb583ec58a450c89d1d9bae4b6.glb";